export enum SNCDashboardDrillDownType {
    Team = 1,
    Status = 2,
    Completed = 3,
    Updated = 4,
    DailyPoints = 5,
}